import { render, staticRenderFns } from "./PicklsInsights.vue?vue&type=template&id=835bff88&"
import script from "./PicklsInsights.vue?vue&type=script&lang=js&"
export * from "./PicklsInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports